import OSfCallingModal from './index.vue';

OSfCallingModal.install = app => {
  app.component(OSfCallingModal.name, OSfCallingModal);
};

export default OSfCallingModal;
